<div class="reports-box" [ngStyle]="{'height': reportsBoxHeight ? reportsBoxHeight : 'auto', 'overflow-y': isUserPerApps ? 'inherit' : null}">
  <div class="reports-box__loading" *ngIf="loading">Carregando...</div>
  <div *ngIf="!loading">
    <div class="reports-box__header" [ngStyle]="{'padding': isSelectVisible ? '0 0 33px 0' : '0 0 10px 0'}">
      <h2 class="reports-box__title">{{title}}</h2>
      <div class="reports-box__select" *ngIf="isSelectVisible">
        <ng-select *ngIf="isDigitalUsages"  [(ngModel)]="selectedProfile" [items]="selectProfiles"
          [bindLabel]="selectBindLabelProfile" (change)="onSelectProfile($event)"
          style="margin-right: 20px;">
        </ng-select>
        <ng-select [items]="selectItems" [(ngModel)]="selectedItem" [bindLabel]="selectBindLabel"
          (change)="selectOnChange($event)">
        </ng-select>
      </div>
      <span class="reports-box__tooltip" [title]="tooltipText">?</span>
    </div>
    <p *ngIf="description">{{ description }}</p>
    <h3 class="reports-box__value" *ngIf="value">{{getValue()}}</h3>

    <ng-content></ng-content>
    <div *ngIf="updateDate" class="update-date-info">
      Última atualização: {{ updateDate }}
    </div>
  </div>
</div>
